import classnames from 'classnames'

import { THEMES } from '../../App'
import { getStoredIsHighContrastMode } from '../../lib/localStorage'
import { CharStatus } from '../../lib/statuses'

type Props = {
  value?: string
  status?: CharStatus
  isRevealing?: boolean
  isCompleted?: boolean
  position?: number
  theme?: string
}

export const Cell = ({
  value,
  status,
  isRevealing,
  isCompleted,
  position = 0,
  theme,
}: Props) => {
  const isFilled = value && !isCompleted
  const shouldReveal = isRevealing && isCompleted
  const animationDelay = `${position * 300}ms`
  const isHighContrast = getStoredIsHighContrastMode()

  const classes = classnames(
    'xxshort:w-11 xxshort:h-11 short:text-2xl short:w-12 short:h-12 w-14 h-14 border-solid border-2 flex items-center justify-center mx-0.5 text-4xl font-bold rounded dark:text-white',
    {
      // No status
      // '': !status && theme === THEMES.colorful,
      'bg-white dark:bg-slate-900 border-slate-200 dark:border-slate-600':
        !status,

      // Current guess, not submitted
      // '': value && !status && theme === THEMES.colorful,
      'border-black dark:border-slate-100': value && !status,

      // Absent
      // '': status === 'absent' && theme === THEMES.colorful,
      'absent shadowed bg-slate-400 dark:bg-slate-700 text-white border-slate-400 dark:border-slate-700':
        status === 'absent',

      // Present
      '!bg-yellow-400':
        status === 'present' && !isHighContrast && theme === THEMES.colorful,
      'present shadowed bg-yellow-500 text-white border-yellow-500':
        status === 'present' && !isHighContrast,

      // Correct
      '!bg-green-400':
        status === 'correct' && !isHighContrast && theme === THEMES.colorful,
      'correct shadowed bg-green-500 text-white border-green-500':
        status === 'correct' && !isHighContrast,

      'cell-fill-animation': isFilled,
      'cell-reveal': shouldReveal,

      // High contrast
      'correct shadowed bg-orange-500 text-white border-orange-500':
        status === 'correct' && isHighContrast,
      'present shadowed bg-cyan-500 text-white border-cyan-500':
        status === 'present' && isHighContrast,
    }
  )

  return (
    <div className={classes} style={{ animationDelay }}>
      <div className="letter-container" style={{ animationDelay }}>
        {value}
      </div>
    </div>
  )
}
